export default __webpack_public_path__ + "static/media/icon_menu_virtual_servers.1fab5e85.svg";